import { render, staticRenderFns } from "./posterDetail.vue?vue&type=template&id=5ad4d048&scoped=true"
import script from "./posterDetail.vue?vue&type=script&lang=js"
export * from "./posterDetail.vue?vue&type=script&lang=js"
import style0 from "./posterDetail.vue?vue&type=style&index=0&id=5ad4d048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad4d048",
  null
  
)

export default component.exports